import Policies from "./policies"

export default Policies
